import { twMerge } from 'tailwind-merge'

const variantStyles = {
  primary: 'bg-zinc-100 ring-zinc-300 ' + 'dark:bg-zinc-600',
}

type Props = {
  variant?: keyof typeof variantStyles
  children?: React.ReactNode
} & React.ComponentPropsWithoutRef<'div'>

export default function Badge({ variant = 'primary', children, className }: Props) {
  className = twMerge(
    'px-2.5 py-1 inline-flex items-center rounded-full text-xs leading-4 font-semibold ring-1 ring-inset',
    variantStyles[variant],
    className,
  )
  return <span className={className}>{children}</span>
}
